export default "__VITE_ASSET__2c1a9941__"